<h3>{{ 'order-details.order-products' | translate }}</h3>
<list-view [selectable]="false">
	<header>{{ 'order-lines.product-name' | translate }}</header>
	<header align-right>{{ 'order-lines.startup' | translate }}</header>
	<header align-right>{{ 'order-lines.payment-interval' | translate }}</header>
	<header align-right>{{ 'order-lines.total-price' | translate }}</header>
	<row *listData="let orderLine from orderLines" [clickable]="editMode" (action)="editLine(orderLine, editorPlacement)" #editorPlacement>
		<column>
			<div>{{ orderLine.productVariant?.product.name }}</div>
			<div>{{ productService.getVariantName(orderLine.productVariant, false, true) }}</div>
		</column>
		<column align-right [sortValue]="orderLine.startupAmount">
			<div>{{ orderLine.startupAmount | currency }}</div>
			@if (orderLine.startupAmount > 0) {
				<div>{{ 'order-lines.startup.number-of-installments' | translate:{ installments: orderLine.startupInstallments } }}</div>
			}
		</column>
		<column align-right [sortValue]="orderLine.paymentInterval">{{ orderLine.paymentInterval | paymentInterval:{ installments: orderLine.numberOfInstallments } }}</column>
		<column align-right>
			<div>{{ orderLine.totalPrice | currency }}</div>
			@if (orderLine.totalPrice < orderLine.productVariant?.price) {
				<div><icon type="circle-info" [trigger-soft-popup]="popupDiscountCalculation" /> ({{ getDiscountPercent(orderLine) | number: '1.0-2' }}%)</div>
			}
		</column>
		<soft-popup #popupDiscountCalculation>
			<section>
				<text-group>
					<span>{{ 'order-lines.popup-discount.variant-price' | translate }}</span>
					<span align-right>{{ orderLine.productVariant?.price | currency }}</span>

					<span>{{ 'order-lines.popup-discount.order-line-price' | translate }}</span>
					<span align-right>{{ orderLine.totalPrice | currency }}</span>

					<span bold>{{ 'order-lines.popup-discount.discount' | translate }}</span>
					<span align-right bold>({{ getDiscountPercent(orderLine) | number: '1.0-2' }}%) {{ (orderLine.productVariant?.price - orderLine.totalPrice) | currency }}</span>
				</text-group>
			</section>
		</soft-popup>
	</row>
	@if (totalDiscount != 0) {
		<row [clickable]="false">
			<column>
				<div>{{ 'order-lines.discount' | translate }}</div>
				@if (discountReason) { <em>{{ discountReason.name }}</em> }
			</column>
			<column />
			<column />
			<column align-right>
				<div>{{ totalDiscount | currency }}</div>
			</column>
		</row>
	}
</list-view>
<editable-content [offsetPosition]="editorOffsetPosition" #editor *editableData="let edit" (valueChanged)="updateOrderLine($event)">
	<edit-content>
		@if (edit.value) {
			<edit-order-line [orderLine]="edit.value" [defaultNumberOfInstallments]="defaultNumberOfInstallments">
				@if (editingOrderLineCanBeRemoved()) {
					<button small reject [ignoreValidation]="true" (click)="removeEditingOrderLine()"><icon type="xmark" />{{ 'order-lines.remove' | translate }}</button>
				}
			</edit-order-line>
		}
	</edit-content>
</editable-content>
@if (editMode) {
	<section>
		<button small (click)="addNewOrderLine()" [loader]="false"><icon type="plus" />{{ 'order-lines.add-new' | translate }}</button>
	</section>
}
